var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[(_vm.user && _vm.user.role === 'admin')?_c('NavbarAdmin'):(_vm.user && _vm.user.role === 'normaluser')?_c('NavbarNormalUser'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container-fluid mt-4"},[_c('child')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc411cf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/layouts/default.vue
// module id = null
// module chunks = 